import '@css/footer.scss';
import { useEffect, useRef, useState } from 'react';
import FamilySite from './FamilySite';

export default function Footer() {
    const familySiteWrapRef = useRef<HTMLDivElement>(null);
    const [isShowFamilySite, setIsShowFamilySite] = useState(false);

    const onFamilyBtnClick = () => setIsShowFamilySite((prev) => !prev);
    const onBacktoTopBtnClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        const handleClickFamilySiteOutside = (evt: MouseEvent) => {
            const isClickOutside = !familySiteWrapRef.current?.contains(evt.target as Node);
            if (isClickOutside) setIsShowFamilySite(false);
        };

        isShowFamilySite
            ? document.addEventListener('click', handleClickFamilySiteOutside)
            : document.removeEventListener('click', handleClickFamilySiteOutside);

        return () => {
            document.removeEventListener('click', handleClickFamilySiteOutside);
        };
    }, [isShowFamilySite]);

    return (
        <footer className="footer">
            <div className="footer__wrap">
                <div className="footer__logo hide-text">NCV GAMES</div>
                <div className="footer__right">
                    <div className="footer__familysite-wrap" ref={familySiteWrapRef}>
                        {isShowFamilySite && <FamilySite />}
                        <button className="footer__familysite-btn" onClick={onFamilyBtnClick}>
                            <span className="footer__familysite-title">FAMILY SITE</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                {!isShowFamilySite && <rect x="5.5" width="1" height="12" fill="#EDEBE6" />}
                                <rect x="12" y="5.5" width="1" height="12" transform="rotate(90 12 5)" fill="#EDEBE6" />
                            </svg>
                        </button>
                    </div>
                    <button className="footer__top-btn" onClick={onBacktoTopBtnClick}>
                        <span className="footer__top-title">BACK TO TOP</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.86631 2.06961L6.86631 15.3828L5.86631 15.3828L5.86631 2.11442L1.29958 6.55383L0.602539 5.83679L6.05766 0.533765L6.41333 0.188013L6.76191 0.540911L12 5.84394L11.2886 6.54668L6.86631 2.06961Z"
                                fill="#EDEBE6"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="footer__desc">ⓒ NCV GAMES PTE.LTD. All Rights Reserved.</div>
        </footer>
    );
}
